import { Guid, ReadonlyCollection } from "@ioip/core/lib";
import Entity from "../../data/types/Entity";
import { IObject } from "../../portal/types";
import { ControlType } from "../../types";
import { DataTable } from "./DataTable";
import { Field } from "./Field";
import { IFieldSchema, defaultIFieldSchema } from "./IFieldSchema";
import { IFormSchema } from "./IFormSchema";

export interface IFormProps {
    object: IObject<IFormSchema>;
}

export class Form {

    #props: IFormProps;
    private __fields: ReadonlyCollection<Field>;
    private __objectId: Guid;

    onRender: () => void;

    constructor(props: IFormProps) {
        this.#props = props;
        this.__rebuidFields();
    }

    private __rebuidFields() {
        this.__fields = new ReadonlyCollection<Field>(this.#props.object.schema.fields.map(x => {
            if (x.controlType == ControlType.dataTable)
                return new DataTable({ schema: x, form: this });
            return new Field({ schema: x, form: this });
        }));
    }

    get objectId(): string {
        return this.#props.object.objectId;
    }

    get name(): string {
        return this.#props.object.name;
    }

    get title(): string {
        return this.#props.object.schema.title;
    }

    get description(): string {
        return this.#props.object.description || '';
    }

    get fields(): ReadonlyCollection<Field> {
        return this.__fields.where(x => x.controlType != ControlType.row);
    }

    get rows(): Field[] {
        return this.__fields.where(x => x.controlType == ControlType.row).orderBy(x => Number(x.order)).toArray();
    }

    get tables(): ReadonlyCollection<DataTable> {
        return this.__fields.where(x => x.controlType == ControlType.dataTable).cast<DataTable>();
    }

    addRow() {
        this.#props.object.schema.fields = [ ...this.#props.object.schema.fields, defaultIFieldSchema(ControlType.row) ];
        this.__rebuidFields();
        this.onRender?.();
    }

    addControl(value: Partial<IFieldSchema>) {
        this.#props.object.schema.fields = [
            ...this.#props.object.schema.fields,
            {
                ...defaultIFieldSchema(value.controlType ?? ControlType.textField),
                ...value
            }
        ];
        this.__rebuidFields();
        this.onRender?.();
    }

    getSchema(): IFormSchema {
        return this.#props.object.schema;
    }

    getField(selectedFieldId: string) {
        return this.fields.single(x => x.id == selectedFieldId);
    }

    updateField(fieldId: string, value: Partial<IFieldSchema>) {
        this.#props.object.schema.fields = this.#props.object.schema.fields.map(x => x.id == fieldId ? { ...x, ...value } : x);
        this.__rebuidFields();
        this.onRender?.();
    }



}